<template>
  <div class="content-box">
    <!-- 로그인한 사용자정보 영역 -->  
    <HconMyPageUsrInfo />
    <div class="sub-wrapper">
      <!-- 마이페이지 사이드 메뉴 -->
      <HconMyPageSideMenu />
      <div class="sub-contents">
        <div class="border-title title">
          <p class="title">구매관리<span class="desc">내가 구매한 Hcon 쿠폰을 쉽고 빠르게 확인해보세요.</span></p>
        </div>
        <div class="box-gray mt28 search">
          <fieldset class="search-form-wrap">
            <legend>구매관리 검색 폼</legend>
            <div class="search-form">
              <div class="form-box">
                <div class="form-group row">
                  <HconDate label="주문일자" v-model="qryDates" />
                </div>
              </div>
              <div class="form-box">
                <div class="form-group row">
                  <HconDropDown type="dropdownBox" label="발송방식" placeholder="전체" v-model="inputValues.qryCpnSndPntmCd" :dropdownOptions="dropDownSndPntm" selectBoxTitleClass="w300" />
                  <HconDropDown type="dropdownBox" label="주문상태" placeholder="전체" v-model="inputValues.qryOrdStCd"      :dropdownOptions="dropDownOrdSt"   selectBoxTitleClass="wd310" labelClass="ml20" />
                </div>
              </div>
              <div class="form-box">
                <div class="form-group row">
                  <HconDropDown type="dropdownBox" label="검색어" placeholder="검색어" v-model="inputValues.qrySrchKey" :dropdownOptions="dropDownKeyword" selectBoxTitleClass="w300" />
                  <HconInput type="text" inputClass="ml20" :placeholder="srchValuePlaceHolder" v-model="inputValues.qrySrchValue" />
                </div>
              </div>
            </div>
            <div class="btn-box">
              <button type="button" class="btn lg" @click="clickSearchButton">조회</button>
            </div>
          </fieldset>
        </div>
        <div class="contents-title-wrap mt40 button">
          <div class="contents-title">
            <h4 class="font-bold">총 <span class="text-green"> {{ totalData }} </span>건</h4>
          </div>
          <div class="rgt-area">
            <HconExcelExport api="/api/v1/mypage/order/list/excel" :query="searchParams">
              <button type="button" class="btn btn-outline" :disabled="cu.isEmpty(orderList)">엑셀다운로드</button>
            </HconExcelExport>
            <HconDropDown type="dropdownBox" :dropdownOptions="dropDownRowPerPage" selectBoxTitleClass="counter ml8" 
                          v-model="stringRowPerPage" />
          </div>
        </div>
        <div class="contents-detail-wrap">
          <table class="tbl-type">
            <caption>최근 구매내역</caption>
            <colgroup>
              <col style="width: 20%;"> 
              <col style="width: auto;">
              <col style="width: 12%;">
              <col style="width: 15%;">
              <col style="width: 15%;">
              <col style="width: 13%;">
            </colgroup>
            <thead>
              <tr>
                <th scope="col">주문번호/주문일시</th>
                <th scope="col">주문명/상품명</th>
                <th scope="col">결제금액</th>
                <th scope="col">주문상태</th>
                <th scope="col">발송방식/발송일시</th>
                <th scope="col">증빙서류</th>
              </tr>
            </thead>
            <tbody v-if="orderList.length > 0">
              <tr v-for="(order, index) in orderList" :key="index">
                <td>
                  <div class="order-number">
                    <NuxtLink :to="getOrderDetailPath(order)" class="link-underline">
                      <p>{{ order.ordNo }}</p>
                      <span>{{ HconCommonUtils.format.dateTimeNoSec(order.ordDtm) }}</span>
                    </NuxtLink>
                  </div>
                </td>
                <td>
                  <div class="product-box">
                    <div class="product-info">
                      <NuxtLink :to="getOrderDetailPath(order)" class="product-tit">
                        <p class="title01">{{ order.ordNm }}</p>
                        <p class="desc01">{{ order.rpsGdsNm }} {{ formatUtil.rpsGdsNm(order.allOrdGdsQty)  }}</p>
                      </NuxtLink>
                    </div>
                  </div>
                </td>
                <td>
                  <strong class="font-bold">{{ HconCommonUtils.format.addWon(order.ordTotAmt) }}</strong>
                </td>
                <td>
                  <p class="title02">{{ order.hcOrdStNm }}</p>
                  <p v-if="order.hcOrdStCd == '1001'" class="desc01">{{ HconCommonUtils.format.dateTimeNoSec(order.ordDtm) }}</p>
                  <p v-if="order.hcOrdStCd == '1002'" class="desc01">{{ HconCommonUtils.format.dateTimeNoSec(order.ordCnclDtm) }}</p>
                  <!--p v-if="order.hcOrdStCd == '1003'" class="desc01">뭐넣지</p-->
                </td>
                <td>
                  <p class="title02">{{ order.hcCpnSndPntmNm }}</p>
                  <p v-if="order.hcCpnSndPntmCd == '1001' || order.hcCpnSndPntmCd == '1003'" class="desc01">{{ HconCommonUtils.format.dateTimeNoSec(order.ordDtm) }}</p>
                  <p v-if="order.hcCpnSndPntmCd == '1002' || order.hcCpnSndPntmCd == '1004'" class="desc01">{{ HconCommonUtils.format.dateTimeNoSec(order.cpnRsvSndDtm) }}</p>
                </td>
                <td>
                  <div class="tbl-btn-box">
                    <button type="button" class="btn btn-outline xs" @click="showDetailedStatementPopup(order.ordNo, order.ordDtm)">거래명세서</button>
                    <button type="button" class="btn btn-outline xs" v-if="order.pgRcptExpsYn === 'Y' && order.pgApvNo != null" @click="showCardReceipt(order.pgApvNo)">거래영수증</button>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="6" class="nodata">구매 내역이 없습니다.</td>
              </tr>
            </tbody>
          </table>
            <HconPagination v-if="totalData > 0" :max-page="totalPage" :current-page="currentPage" @update:currentPage="handlePagination" />
        </div>
      </div>
    </div> 
  </div>
  <!-- 거래명세서 팝업 -->
  <HconOrderPopupDetailedStatement ref="popupDetailedStatementRef" />
</template>
<script lang="ts" setup>
import { ref, reactive, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { usePopup } from '@/composables/hconUsePopup';
import HconInput from '@/components/com/HconComPCInputField.vue';
import HconDropDown from '@/components/com/HconComPCDropDown.vue';
import HconPagination from '@/components/com/HconComPCPagination.vue';
import HconDate from '@/components/com/HconComPCDateButton.vue';
import HconExcelExport from "@/components/com/HconComPCExcelExport.vue";
import HconMyPageSideMenu from '@/components/corner/pc/HconCornerMypageSideMenuPC.vue';
import HconMyPageUsrInfo from '@/components/corner/pc/HconCornerUserInfoPC.vue';
import { HconCommonUtils } from "@/utils/hcon-common-utils";
import HconOrderPopupDetailedStatement from '@/components/popup/HconOrderPopupDetailedStatement.vue';
import { usePayment, type ReceiptParams } from '@/composables/usePayment';
const { openInicisReceipt } = usePayment()

const showCardReceipt = async(pgApvNo: string) => {
  var params: ReceiptParams = {
      "tid": pgApvNo
    , "noTid": pgApvNo
    , "subMerchantoid": ""
    , "rt": "-1"
    , "reMail": 'null'
  }
  openInicisReceipt(params)
}

// PIN주문 상세화면 분기처리
const getOrderDetailPath = (order: MyPageOrderDto) => {
  if(order.hcOrdTypCd === '1002') { 
    return `/pc/mypage/order/pin-detail/${order.ordNo}`;
  } else {
    return `/pc/mypage/order/detail/${order.ordNo}`;
  }
}

// 드롭다운 그리기 
const dropDownOrdSt = [ // 주문상태
    {key: '', value: '전체'}
  , {key: '1001', value: '결제완료'}
  , {key: '1002', value: '결제취소'}
  , {key: '1003', value: '부분결제취소'}
];
const dropDownSndPntm = [ // 발송시점
    {key: '', value: '전체'}
  , {key: '1001', value: '즉시발송'}
  , {key: '1002', value: '예약발송'}
  , {key: '1003', value: '핀 즉시발행'}
  , {key: '1004', value: '핀 예약발행'}
]; 
const dropDownKeyword = [ // 키워드(검색어)
    {key: 'ordNo', value: '주문번호'}
  , {key: 'ordNm', value: '주문명'}
  , {key: 'gdsNm', value: '상품명'}
  , {key: 'rcvrTelNo', value: '수신번호'}
]; 
const dropDownRowPerPage = [ // 페이징건수
    {key: '20', value: '20개씩 보기'}
  , {key: '40', value: '40개씩 보기'}
  , {key: '100', value: '100개씩 보기'}
];

//////////////////////////////////////////////
//       목록조회 시 페이징 처리 관련 모음
//////////////////////////////////////////////
/**
 * 1. 아래의 변수 4종과 함수 2종 선언
 * 2. 페이지네이션 컴포넌트는 HconComPCPagination.vue 사용
 * 3. API호출 시 아래 2종 반영
      3.1. .query 부분, pageNum & pageSize도 쿼리스트링에 포함 필요
      3.2. .then 부분, 총건수 세팅 필요
                       ex) ((result) => {
                             totalData.value = result.total || 0;
                           })
 * 4. 서비스(hcon-fo-api)에서는 아래 2종 반영
      4.1. requestDto에 int pageNum; & int pageSize; 추가
      4.2. controller에서 startPage(); 추가
 **/
// 1. 페이지네이션 매핑대상 변수 준비
const currentPage = ref<number>(1);  // 페이징 번호
const rowPerPage  = ref<number>(20); // 페이징 건수
const totalData   = ref<number>(0);  // 총 데이터 건수
const totalPage = computed (() => {  // 총 페이지 건수(계산식)
  if(orderList.value.length === 0) return 0;
  return Math.ceil(totalData.value / rowPerPage.value);
});

// 2. 페이지네이션 클릭이벤트 핸들링 함수
const handlePagination = (pageNum: number) => {
  // 2.1. 숫자 클릭 시, 현재페이지를 새값으로 바꾸고 API호출
  currentPage.value = pageNum; 
  getOrderList();
}

// 추가기능1: 건수변경 드롭다운이 있을 경우, v-model 연결 및 API 즉시호출
const stringRowPerPage = computed({
  get: () => String(rowPerPage.value),
  set: (newVal: string) => {
    rowPerPage.value = Number(newVal);
    if(typeof currentPage !== 'undefined') {
      currentPage.value = 1;
    }
    getOrderList();
  }
})

// 추가기능2: 조회조건에 따른 (재)조회버튼이 있을 경우, 1페이지로 재설정 필요
const clickSearchButton = () => {
  currentPage.value = 1;
  getOrderList();
}




// DTO 준비
import type { MyPageOrderDto } from '@/types/order/backend-dto-types';
// 팝업 준비
const { showAlert, showConfirm } = usePopup()
// API 호출 준비
const fetchBuilder  = useHconFetchBuilder();
// 화면 마운트 (목록조회 즉시 실행)
onMounted(() => {getOrderList()});

// 마이페이지 주문내역 목록 매핑대상 준비
const orderList = ref<MyPageOrderDto[]>([]);
// 조회조건 입출력용 매핑대상 준비
const qryDates = ref<[Date, Date] | null>(null);
const inputValues = ref({
    qryCpnSndPntmCd: '' // 조회쿠폰발송시점코드
  , qryOrdStCd: '' // 조회주문상태코드
  , qrySrchKey: '' // 조회키 [ordNo, ordNm, gdsNm, rcvrTelNo]
  , qrySrchValue: '' // 조회값 [주문번호, 주문명, 상품명, 수신자번호]
});
// 조회조건 읽기전용 매핑대상 준비
const searchParams = computed(() => {
  const qryStartDate = qryDates.value? HconCommonUtils.format.date(qryDates.value[0],'YYYYMMDD') : '';
  const qryEndDate = qryDates.value? HconCommonUtils.format.date(qryDates.value[1],'YYYYMMDD') : '';
  return {
    ...inputValues.value
    , qryStrtDt: qryStartDate // 조회시작일자
    , qryEndDt: qryEndDate // 조회종료일자
    , pageNum: currentPage.value
    , pageSize: rowPerPage.value
  }
})
// 마이페이지 주문내역 목록 조회
const getOrderList = async () => {
  if(await checkSearchAvailable()) {
    // API 호출
    const orderListFetcher =
      fetchBuilder.get<TableDataInfo<MyPageOrderDto>>('/api/v1/mypage/order/list')
      .query(searchParams.value)
      .progressMessage("잠시만 기다려주세요...")
      .build()
      .execute()
      .then((result) => {
        if(result.resultCode != '200') {
          showAlert(result.resultMessage);
        } else {
          // ref 형식 변수에 값 즉시 세팅
          orderList.value = result.data || [];
          // 페이지네이션 처리
          totalData.value = result.total || 0;
        }
    });
  }
}

// 검색조건 체크 함수
const checkSearchAvailable = async () => {
  // 검색어를 입력했는데, 드롭다운 미선택 시 false 반환
  if(searchParams.value.qrySrchValue !== '' && searchParams.value.qrySrchKey === '') {
    showAlert('검색어를 선택해 주세요.');
    return false;
  } 
  if(searchParams.value.qrySrchValue === '' && searchParams.value.qrySrchKey !== '') {
    showAlert('검색어를 입력해 주세요.');
    return false;
  } 
  return true;
}

// 데이터 포맷팅 반환 함수
const formatUtil = {
  // 대표상품명 + 총상품구매수량
  rpsGdsNm: (val: number) => {
    if(!val || val <= 1) return '';
    if(val > 1) {
      const newVal = val - 1;
      return '외 ' + newVal + '건';
    }
  },
  telNo: (val: string | undefined) => {
    if(!val) return '-';
    if(val.length === 8) {
      return val.replace(/(\d{4})(\d{4})/, '$1-$2');
    }
    return val.replace(/^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?([0-9]{3,4})-?([0-9]{4})$/, '$1-$2-$3');  
  }
}

// 검색어 플레이스홀더 변경 함수
const srchValuePlaceHolder = computed(() => {
  const defaultPH = '검색어를 선택하세요'
  const currentKey = inputValues.value.qrySrchKey;
  const foundItem = dropDownKeyword.find(item => item.key === currentKey);
  if (!foundItem) return defaultPH;
  // 받침에 따른 조사처리는 유니코드 검색하지 않고 하드코딩함.
  const label = foundItem.value;
  if (label === '주문번호' || label === '수신번호') return `${label}로 검색해주세요`;
  if (label === '주문명' || label === '상품명') return `${label}으로 검색해주세요`;
})

// 거래명세서 조회 팝업
const popupDetailedStatementRef = ref<InstanceType<typeof HconOrderPopupDetailedStatement> | null>(null);
const showDetailedStatementPopup = (ordNo:string, ordDtm:string ) => {
   popupDetailedStatementRef.value?.handleOpen(ordNo, ordDtm);
};

</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/order-hcon.scss" as *;
@use "@/assets/scss/pc/mypage-hcon.scss" as *;

</style>